<template>
  <div class="flex flex-column gap-3">
    <create-company :visible.sync="visibleCreateCompany" />

    <div class="flex justify-content-between">
      <h3 class="m-0">Your Companies</h3>
      <a-button @click="visibleCreateCompany = true" icon="plus">Create Company</a-button>
    </div>
    <all-projects />
  </div>
</template>

<script>
import AllProjects from '@/modules/project/components/all-projects.vue'
import ProjectCreate from '@/modules/project/components/project-create.vue'
import { Button } from 'ant-design-vue'

export default {
  components: {
    'all-projects': AllProjects,
    'a-button': Button,
    'create-company': ProjectCreate
  },
  data() {
    return {
      visibleCreateCompany: false
    }
  }
}
</script>
